import { useParams } from 'react-router';
import SettingsPanel from '@/components/core/SettingsPanel';
import ExportUnitsGrid from '@/components/exportUnits/ExportUnitsGrid';
import { paramActions } from '@/stores/paramStore';
import { exportUnitsActions, useExportUnitSettings } from '@/stores/exportUnitsStore';

const ExportUnitsPanel = () => {
  const { projectId } = useParams();
  const settings = useExportUnitSettings();

  const onSave = async (name, unit) => {
    paramActions.setSavePending(true);

    try {
      await exportUnitsActions.updateProject(projectId, name, unit);
      paramActions.setSavePending(false);
    } catch (error) {
      paramActions.setSavePending(null);
      throw error;
    }
  };

  return (
    <SettingsPanel title="Export Units">
      <ExportUnitsGrid
        caption="Units for Excel exports from every pathway and comparison in this project. Charts aren't affected."
        settings={settings}
        onSave={onSave}
      />
    </SettingsPanel>
  );
};

export default ExportUnitsPanel;
